import { useLoading } from "../context/LoadingContext";
import { Loader2 } from "lucide-react";
import styled from "styled-components";
import { colors } from "../styles/colors";

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 9999;
`;

const Loader = styled(Loader2)`
  width: 50px;
  height: 50px;
  color: ${colors.primary};
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Loading = () => {
  const { isLoading } = useLoading();
  if (!isLoading) return null;
  return (
    <LoadingOverlay>
      <Loader />
    </LoadingOverlay>
  );
};

export default Loading;
